import Dialog from "@components/Dialog"
import { Button, Typography } from "@mui/material"
import { atom, useAtom } from "jotai"
import { atomWithStorage } from "jotai/utils"

const navigationDialogOpenAtom = atom(true)
const navigationDialogSeenAtom = atomWithStorage("graph-navigation-dialog-seen", false)

if (process.env.NODE_ENV !== "production") {
  navigationDialogOpenAtom.debugLabel = "navigationDialogOpenAtom"
  navigationDialogSeenAtom.debugLabel = "navigationDialogSeenAtom"
}

export const GraphNavigationDialog = () => {
  const [open, setOpen] = useAtom(navigationDialogOpenAtom)
  const [seen, setSeen] = useAtom(navigationDialogSeenAtom)

  if (seen) return <></>

  const handleClose = () => setOpen(false)
  const handleSeen = () => {
    setSeen(true)
    setOpen(false)
  }

  return (
    <>
      <Dialog
        open={open}
        title="Quick Tip"
        onClose={handleClose}
        closeOnBackdropClick
        actionsComponent={
          <>
            <Button variant="outlined" onClick={handleSeen}>
              Don't show again
            </Button>
            <Button variant="contained" onClick={handleClose}>
              Close
            </Button>
          </>
        }
      >
        <Typography>
          Hold <strong>Space</strong> and drag with your mouse to move around the graph, or hold the{" "}
          <strong>middle mouse button</strong> and drag
        </Typography>
      </Dialog>
    </>
  )
}
